import { render, staticRenderFns } from "./FRDefinitionOfRanks.vue?vue&type=template&id=b979a252&scoped=true&"
import script from "./FRDefinitionOfRanks.vue?vue&type=script&lang=js&"
export * from "./FRDefinitionOfRanks.vue?vue&type=script&lang=js&"
import style0 from "./FRDefinitionOfRanks.vue?vue&type=style&index=0&id=b979a252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b979a252",
  null
  
)

export default component.exports